// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
.project {
  padding: 80px 0;
  position: relative;
  background-color: #ebe9cd;
}

.project h2 {
  font-size: 45px;
  font-weight: 700;
  text-align: center;
  color: var(--green);
}

.project p {
  color: var(--dark-green);
  font-size: 18px;
  letter-spacing: 0.8px;
  line-height: 1.5em;
  margin: 14px auto 30px auto;
  text-align: center;
  width: 56%;
}

.project .nav.nav-pills {
  width: 72%;
  margin: 0 auto;
  border-radius: 50px;
  background-color: rgb(255 255 255 / 10%);
  overflow: hidden;
}

.project .nav.nav-pills .nav-item {
  width: 50%;
}

.project .nav.nav-pills .nav-link {
  background-color: transparent;
  border-radius: 0;
  padding: 17px 0;
  color: var(--red);
  width: 100%;
  font-size: 17px;
  letter-spacing: 0.8px;
  font-weight: 500;
  position: relative;
  transition: 0.3s ease-in-out;
  text-align: center;
  z-index: 0;
}

.tour-route-link {
  color: white;
}

.project .nav.nav-pills .nav-link::before {
  content: "";
  position: absolute;
  width: 0;
  height: 100%;
  background: linear-gradient(90.21deg, var(--green) -5.91%, var(--dark-green) 111.58%);
  top: 0;
  left: 0;
  z-index: -1;
  transition: 0.3s ease-in-out;
}

.project .nav.nav-pills .nav-link.active::before {
  width: 100% !important;
}

.project .nav.nav-pills .nav-link.active {
  border: 1px solid rgba(255, 255, 255, 1);
}

.nav-link#projects-tabs-tab-first {
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 55px 0px 0px 55px;
}

.nav-link#projects-tabs-tab-second {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.background-image-right {
  top: 20%;
  position: absolute;
  bottom: 0;
  width: 35%;
  right: 0;
  z-index: -4;
}

.slider {
  position: relative;
  margin-top: 100px;
  width: 100%;
  height: 370px;
  overflow: hidden;
}

.gallery-button {
  width: 60px;
  height: 60px;
  background: var(--green);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  border: none;
  text-decoration: none;
  transition: background 0.2s;
}
.gallery-button:hover {
  background: var(--dark-green);
}

#next {
  position: absolute;
  right: 50px;
  top: 40%;
  z-index: 1000;
}

#prev {
  position: absolute;
  left: 50px;
  top: 40%;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/Projects/Projects.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,qFAAqF;EACrF,MAAM;EACN,OAAO;EACP,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;AACf","sourcesContent":["/**\n * Copyright 2025 Paion Data. All rights reserved.\n */\n.project {\n  padding: 80px 0;\n  position: relative;\n  background-color: #ebe9cd;\n}\n\n.project h2 {\n  font-size: 45px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--green);\n}\n\n.project p {\n  color: var(--dark-green);\n  font-size: 18px;\n  letter-spacing: 0.8px;\n  line-height: 1.5em;\n  margin: 14px auto 30px auto;\n  text-align: center;\n  width: 56%;\n}\n\n.project .nav.nav-pills {\n  width: 72%;\n  margin: 0 auto;\n  border-radius: 50px;\n  background-color: rgb(255 255 255 / 10%);\n  overflow: hidden;\n}\n\n.project .nav.nav-pills .nav-item {\n  width: 50%;\n}\n\n.project .nav.nav-pills .nav-link {\n  background-color: transparent;\n  border-radius: 0;\n  padding: 17px 0;\n  color: var(--red);\n  width: 100%;\n  font-size: 17px;\n  letter-spacing: 0.8px;\n  font-weight: 500;\n  position: relative;\n  transition: 0.3s ease-in-out;\n  text-align: center;\n  z-index: 0;\n}\n\n.tour-route-link {\n  color: white;\n}\n\n.project .nav.nav-pills .nav-link::before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 100%;\n  background: linear-gradient(90.21deg, var(--green) -5.91%, var(--dark-green) 111.58%);\n  top: 0;\n  left: 0;\n  z-index: -1;\n  transition: 0.3s ease-in-out;\n}\n\n.project .nav.nav-pills .nav-link.active::before {\n  width: 100% !important;\n}\n\n.project .nav.nav-pills .nav-link.active {\n  border: 1px solid rgba(255, 255, 255, 1);\n}\n\n.nav-link#projects-tabs-tab-first {\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 55px 0px 0px 55px;\n}\n\n.nav-link#projects-tabs-tab-second {\n  border-top: 1px solid rgba(255, 255, 255, 0.5);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n.background-image-right {\n  top: 20%;\n  position: absolute;\n  bottom: 0;\n  width: 35%;\n  right: 0;\n  z-index: -4;\n}\n\n.slider {\n  position: relative;\n  margin-top: 100px;\n  width: 100%;\n  height: 370px;\n  overflow: hidden;\n}\n\n.gallery-button {\n  width: 60px;\n  height: 60px;\n  background: var(--green);\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 50%;\n  border: none;\n  text-decoration: none;\n  transition: background 0.2s;\n}\n.gallery-button:hover {\n  background: var(--dark-green);\n}\n\n#next {\n  position: absolute;\n  right: 50px;\n  top: 40%;\n  z-index: 1000;\n}\n\n#prev {\n  position: absolute;\n  left: 50px;\n  top: 40%;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
